export const GD_WDS_EXPERIMENT = 'globalDesignWDSMigration';
